import { Card, Col, Flex, Row } from 'antd'
import dayjs from 'dayjs'

import { EpidemiologyCaseForm058E_RegistrationSection } from 'src/api/requests'
import { Text } from 'src/components'
import { dayMonthYearHourMinutesFormatWithDot } from 'src/libs'
import { useLocales } from 'src/locales'

type Props = {
  registration: EpidemiologyCaseForm058E_RegistrationSection
}

export const EpidemiologyRegistrationDetailsCard = ({
  registration
}: Props) => {
  const { t } = useLocales()

  return (
    <Card title={t('epidemiology.registration_title')}>
      <Row gutter={[24, 24]}>
        <Col span={8}>
          <Flex vertical gap={4}>
            <Text>{t('epidemiology.institution_that_registered')}</Text>
            <Text weight={400}>{registration.institutionTitle}</Text>
          </Flex>
        </Col>

        <Col span={8}>
          <Flex vertical gap={4}>
            <Text>{t('epidemiology.date_time_registration')}</Text>
            <Text weight={400}>
              {registration.registrationDate
                ? dayjs(registration.registrationDate).format(
                    dayMonthYearHourMinutesFormatWithDot
                  )
                : '-'}
            </Text>
          </Flex>
        </Col>

        <Col span={8}>
          <Flex vertical gap={4}>
            <Text>{t('epidemiology.updated_date')}</Text>
            <Text weight={400}>
              {registration.updateDate
                ? dayjs(registration.updateDate).format(
                    dayMonthYearHourMinutesFormatWithDot
                  )
                : '-'}
            </Text>
          </Flex>
        </Col>

        <Col span={8}>
          <Flex vertical gap={4}>
            <Text>{t('epidemiology.person_who_registered')}</Text>
            <Text weight={400}>{registration.personFullName}</Text>
          </Flex>
        </Col>

        <Col span={8}>
          <Flex vertical gap={4}>
            <Text>{t('common.phone')}</Text>
            <Text weight={400}>{registration.personPhone}</Text>
          </Flex>
        </Col>
      </Row>
    </Card>
  )
}
